import { LANG } from '../../../../Common/CookieSettings/CookieConstants';
import { getCookie } from '../../../../Common/CookieSettings/CookieUtils';

export const getLanguageContext = (language: string = getCookie(LANG) || 'EN'): string => {
  return `@inContext(language: ${language.toUpperCase()})`;
};
